import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';

import { MapContext } from '../../context/map';
import useTranslation from '../../hooks/use_translation';
import LocationItem from './item';

const LocationMapList = ({ handleGotoMarker }) => {
	const { geoLocationState, locations, map, matches, setMatches } =
		useContext(MapContext);
	const { t } = useTranslation('component_location_map_item');

	const onGotoMarker = (event, marker) => {
		event.preventDefault();
		map.panTo(marker.getPosition());
		map.setZoom(14);
		if (handleGotoMarker) handleGotoMarker();
	};

	useEffect(() => {
		if (map) {
			window.google.maps.event.addListener(map, 'idle', () => {
				const bounds = map.getBounds();
				let item = [];
				let sort_locations = Object.values(locations);

				if (geoLocationState?.position) {
					sort_locations.sort(function (a, b) {
						return a?.data?.position?.distance - b?.data?.position?.distance;
					});
				}

				for (const location of sort_locations) {
					if (bounds.contains(location.marker.getPosition())) {
						item.push(location.data.location_id);
					}
				}

				setMatches(item);
			});
		}
	}, [geoLocationState, locations, map, setMatches]);

	return (
		<>
			{matches?.length > 0 && (
				<>
					<p className="xs mt-2 position-absolute top-0 start-0 ps-3 pt-2 fw-700">
						{t('t1', {
							count:
								matches?.filter((item) => locations[item]?.marker?.map)
									?.length ?? 0,
						})}
					</p>
					{matches.map((item) => {
						const location = locations[item].data;
						const marker = locations[item].marker;
						if (!marker?.map) return;

						return (
							<LocationItem
								address={location.address}
								city={location.city}
								className="border-bottom"
								diagnostics={location.diagnostics}
								groups={location.groups}
								key={`map_list_matches_${location.location_id}`}
								location_id={location.location_id}
								location_settings={location.location_settings}
								onGotoMarker={(event) => onGotoMarker(event, marker)}
								position={geoLocationState?.position ? location.position : null}
								title={location.title}
								visit_type={location.visit_type}
								zip_code={location.zip_code}
							/>
						);
					})}
				</>
			)}

			{Object.keys(locations).length > 0 && (!matches || !matches.length) && (
				<>
					<div className="alert alert-warning p-1 mt-1">
						<p className="xs mb-0">{t('t2')}</p>
					</div>

					<p className="xs fw-700 mt-3">{t('t3')}</p>
					{Object.values(locations).map((item) => {
						const location = item.data;
						const marker = item.marker;
						if (!marker?.map) return;

						return (
							<LocationItem
								address={location.address}
								city={location.city}
								className="border-bottom"
								diagnostics={location.diagnostics}
								groups={location.groups}
								key={`map_list_${location.location_id}`}
								location_id={location.location_id}
								location_settings={location.location_settings}
								onGotoMarker={(event) => onGotoMarker(event, marker)}
								position={location.position}
								title={location.title}
								visit_type={location.visit_type}
							/>
						);
					})}
				</>
			)}
		</>
	);
};

LocationMapList.propTypes = {
	handleGotoMarker: PropTypes.func,
};

export default LocationMapList;
